var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChampagneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.0685 101.933C76.0657 101.936 76.0637 101.939 76.0627 101.943C75.9683 102.31 75.846 102.667 75.7143 103.025C72.6881 111.29 63.2501 116.198 53.4528 114.193C43.646 112.188 36.8843 103.97 37.3572 95.1753C37.3666 94.8349 37.2437 95.1091 37.4423 94.154C37.5902 93.4237 38.2892 90.9949 38.6209 89.8789C38.6359 89.8286 38.6415 89.7773 38.6602 89.7282V89.7282C38.6721 89.6968 38.6858 89.6646 38.695 89.6324L38.7568 89.4161V89.4161C38.7749 89.3528 38.7939 89.2898 38.8114 89.2263L51.0649 44.7232C51.9032 41.6786 54.9578 39.8049 58.0516 40.4376L79.0161 44.7245C82.1468 45.3647 84.2265 48.3463 83.7457 51.5055L76.7073 97.7571L76.0748 101.92C76.0741 101.925 76.0719 101.929 76.0685 101.933V101.933Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2104 87.1367C39.201 87.2029 39.1631 87.2975 39.1348 87.4299L39.2104 87.1367Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4199 155.652L53.4511 114.193",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9054 158.3L34.0176 154.233",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.164 94.0123L136.133 89.4541",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.486 95.7992C137.533 96.1775 137.552 96.5558 137.561 96.9341C137.807 105.729 130.857 113.786 121.002 115.545C111.158 117.304 101.824 112.169 99.0152 103.828C98.9017 103.507 98.8828 103.809 98.7126 102.854C98.4927 101.614 98.3458 99.505 98.2113 98.2486C98.1978 98.1221 98.183 97.9975 98.183 97.8703L93.0975 51.8987C92.7503 48.7596 94.8959 45.8888 98.0048 45.3327L119.067 41.5656C122.213 41.003 125.247 43.0044 125.969 46.1174L136.531 91.6949L137.486 95.7992Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.164 94.0127C137.221 94.4383 137.249 94.8544 137.268 95.2705",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.586 153.288L121.002 115.545",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.102 151.396L119.129 154.971",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1758 36.0973L103.867 24.5693",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.293 30.3861V19",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8414 34.6137L73.9922 25.2324",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampagneIcon);
export default __webpack_public_path__ + "static/media/champagne-icon.a06bdf3f7e80e736e3573e0e08732825.svg";
export { ForwardRef as ReactComponent };